import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.error');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ErrorConfig = {
    eyebrow: string;
    title: string;
    description: string;
    action: string;
};

@Component({
    selector: 'wiz-page-error',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.error/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.error-page {
  --ink: #132a27;
  --green: #244d47;
  --green-soft: #e8f1ee;
  --orange: #a5632f;
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  overflow: hidden;
  background: #f7f9f8;
  color: var(--ink);
  font-family: "SUIT", "Pretendard", sans-serif;
}

.error-atmosphere,
.error-glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.error-atmosphere {
  background-image: linear-gradient(rgba(36, 77, 71, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(36, 77, 71, 0.035) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: linear-gradient(to bottom, black, transparent 76%);
}

.error-glow {
  border-radius: 999px;
  filter: blur(10px);
}

.error-glow-one {
  inset: -22rem auto auto -18rem;
  width: 42rem;
  height: 42rem;
  background: rgba(183, 213, 203, 0.32);
}

.error-glow-two {
  inset: auto -17rem -23rem auto;
  width: 39rem;
  height: 39rem;
  background: rgba(226, 189, 150, 0.17);
}

.error-header {
  position: relative;
  z-index: 1;
  width: min(1180px, 100% - 48px);
  margin: 0 auto;
  padding: 28px 0;
}

.error-brand {
  display: inline-flex;
  align-items: center;
  gap: 13px;
  color: inherit;
  text-decoration: none;
}

.error-brand img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.error-brand span {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.error-brand strong {
  font-size: 15px;
  letter-spacing: -0.02em;
}

.error-brand small {
  color: #72827f;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.error-shell {
  position: relative;
  z-index: 1;
  display: grid;
  width: min(1040px, 100% - 48px);
  margin: auto;
  grid-template-columns: minmax(300px, 0.8fr) minmax(420px, 1.2fr);
  align-items: center;
  gap: clamp(44px, 8vw, 112px);
  padding: 44px 0 92px;
}

.error-visual {
  position: relative;
  display: flex;
  min-height: 330px;
  align-items: center;
  justify-content: center;
}

.error-code-shadow {
  position: absolute;
  color: rgba(36, 77, 71, 0.07);
  font-size: clamp(150px, 18vw, 250px);
  font-weight: 900;
  letter-spacing: -0.1em;
  line-height: 1;
  transform: translateX(-0.04em);
  user-select: none;
}

.error-icon-ring {
  position: relative;
  display: flex;
  width: 116px;
  height: 116px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(36, 77, 71, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 24px 60px rgba(25, 59, 54, 0.12), inset 0 0 0 10px rgba(232, 241, 238, 0.72);
  color: var(--orange);
  backdrop-filter: blur(12px);
}

.error-icon-ring svg {
  width: 46px;
  height: 46px;
}

.error-copy {
  max-width: 560px;
}

.error-eyebrow {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  border-radius: 999px;
  background: var(--green-soft);
  padding: 0 12px;
  color: var(--green);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.13em;
}

.error-code-mobile {
  display: none;
}

.error-copy h1 {
  margin: 22px 0 0;
  color: #10231f;
  font-size: clamp(32px, 4vw, 48px);
  font-weight: 900;
  letter-spacing: -0.045em;
  line-height: 1.15;
  word-break: keep-all;
}

.error-description {
  max-width: 520px;
  margin: 22px 0 0;
  color: #62736f;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.8;
  word-break: keep-all;
}

.error-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 34px;
}

.error-actions button {
  height: 46px;
  border-radius: 12px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 800;
  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease;
}

.error-actions button:hover {
  transform: translateY(-1px);
}

.error-primary {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 0;
  background: var(--green);
  color: white;
  box-shadow: 0 12px 26px rgba(36, 77, 71, 0.19);
}

.error-primary:hover {
  background: #193b36;
}

.error-primary svg {
  width: 17px;
  height: 17px;
}

.error-secondary {
  border: 1px solid #d7dfdc;
  background: white;
  color: #3e514d;
}

.error-secondary:hover {
  border-color: #aabbb6;
}

.error-link {
  border: 0;
  background: transparent;
  color: #657773;
}

.error-help {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 30px;
  border-top: 1px solid #e0e6e4;
  padding-top: 18px;
  color: #7c8b88;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.65;
}

.error-help p {
  margin: 0;
}

.error-help strong {
  color: #536661;
}

.error-help-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--orange);
}

.error-footer {
  position: relative;
  z-index: 1;
  display: flex;
  width: min(1180px, 100% - 48px);
  margin: 0 auto;
  justify-content: center;
  gap: 8px;
  border-top: 1px solid rgba(36, 77, 71, 0.1);
  padding: 20px 0 24px;
  color: #87938f;
  font-size: 10px;
  font-weight: 700;
}

@media (max-width: 820px) {
  .error-header {
    width: min(100% - 32px, 680px);
    padding-top: 20px;
  }
  .error-shell {
    width: min(100% - 32px, 620px);
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 42px 0 68px;
  }
  .error-visual {
    min-height: 160px;
  }
  .error-code-shadow {
    font-size: 150px;
  }
  .error-icon-ring {
    width: 88px;
    height: 88px;
  }
  .error-icon-ring svg {
    width: 36px;
    height: 36px;
  }
  .error-copy {
    text-align: center;
  }
  .error-copy h1 {
    font-size: 32px;
  }
  .error-description {
    margin-inline: auto;
    font-size: 14px;
  }
  .error-actions {
    justify-content: center;
  }
  .error-help {
    justify-content: center;
    text-align: left;
  }
  .error-footer {
    width: calc(100% - 32px);
    flex-wrap: wrap;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .error-brand small {
    display: none;
  }
  .error-shell {
    padding-top: 24px;
  }
  .error-visual {
    min-height: 132px;
  }
  .error-code-shadow {
    font-size: 116px;
  }
  .error-icon-ring {
    width: 72px;
    height: 72px;
  }
  .error-icon-ring svg {
    width: 30px;
    height: 30px;
  }
  .error-eyebrow {
    display: none;
  }
  .error-code-mobile {
    display: block;
    margin: 8px 0 0;
    color: var(--orange);
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.12em;
  }
  .error-copy h1 {
    margin-top: 12px;
    font-size: 27px;
  }
  .error-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .error-actions button {
    width: 100%;
  }
  .error-link {
    grid-column: 1/-1;
  }
}`],
})
export class PageErrorComponent implements OnInit {
    public code: string = '500';
    public config: ErrorConfig = this.errorConfig('500');
    public returnTo: string = '/home';
    public occurredAt: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        const requested = `${WizRoute.segment.code || '500'}`;
        this.code = ['404', '500', '501', '503'].includes(requested) ? requested : '500';
        this.config = this.errorConfig(this.code);
        const query = new URLSearchParams(location.search);
        const returnTo = query.get('returnTo') || '/home';
        this.returnTo = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/home';
        this.occurredAt = new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
        }).format(new Date());
        document.title = `${this.code} · ${this.config.title} | 동북아역사 자료함`;
        // The error page must remain usable even while service initialization
        // is the failing operation.
        try {
            await this.service.init();
            await this.service.render();
        } catch (_error) { }
    }

    public retry() {
        if (this.code === '404') {
            location.href = this.returnTo;
            return;
        }
        location.reload();
    }

    public goHome() { location.href = '/home'; }

    public goBack() {
        if (history.length > 1) history.back();
        else this.goHome();
    }

    private errorConfig(code: string): ErrorConfig {
        const configs: { [key: string]: ErrorConfig } = {
            '404': {
                eyebrow: 'PAGE NOT FOUND',
                title: '요청하신 페이지를 찾을 수 없습니다',
                description: '주소가 변경되었거나 삭제된 페이지일 수 있습니다. 이전 화면으로 돌아가거나 자료함 홈에서 다시 찾아보세요.',
                action: '이전 화면으로',
            },
            '500': {
                eyebrow: 'INTERNAL SERVER ERROR',
                title: '요청을 처리하는 중 문제가 발생했습니다',
                description: '작성 중인 내용은 가능한 한 유지했습니다. 잠시 후 다시 시도해 주세요. 같은 문제가 반복되면 관리자에게 알려주세요.',
                action: '다시 시도',
            },
            '501': {
                eyebrow: 'NOT IMPLEMENTED',
                title: '아직 제공하지 않는 기능입니다',
                description: '요청하신 기능은 현재 준비 중입니다. 자료함 홈에서 이용 가능한 다른 기능을 확인해 주세요.',
                action: '자료함으로',
            },
            '503': {
                eyebrow: 'SERVICE UNAVAILABLE',
                title: '서비스 연결을 다시 준비하고 있습니다',
                description: '서버 연결이 잠시 끊겼습니다. 작업 데이터는 삭제되지 않았으며, 잠시 후 다시 시도하면 이어서 이용할 수 있습니다.',
                action: '다시 시도',
            },
        };
        return configs[code] || configs['500'];
    }
}

export default PageErrorComponent;